import React from 'react';
import PropTypes from 'prop-types';
import { Flag, Flex } from 'nallian-shared-ui/lib/components';
import CountryName from '../../../app/components/CountryName';

const Country = ({ value }) => {
  return (
    <Flex alignItems="center">
      <Flag name={value.toLowerCase()} />
      &nbsp;
      <CountryName code={value} />
    </Flex>
  );
};

Country.propTypes = { value: PropTypes.string.isRequired };

export default Country;
